import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../../../../core/auth/_services';
import { CommentsService } from '../../../../../core/services/comments.service';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'kt-comments-dialog',
  templateUrl: './comments-dialog.component.html',
  styleUrls: ['./comments-dialog.component.scss'],
})
export class CommentsDialogComponent implements OnInit {
  comments: any;
  followupId: any;
  transactionId: number;
  transactionType: string;
  height: number;
  postedFirstComment = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<CommentsDialogComponent>,
    private commentService: CommentsService,
  ) {
    this.comments = this.data.comments || [];
    this.transactionId = this.data.transactionId || null;
    this.followupId = this.data.followup_id || null;
    this.transactionType = this.data.transactionType || null;
    this.height = this.data.height || null;
  }

  ngOnInit(): void {
    if (this.transactionType === 'TASK') {
      this.loadCommentsFromService();
    } else {
      this.getComments();
    }
  }

  loadCommentsFromService() {
    this.commentService
      .getComments(this.transactionType, this.transactionId)
      .pipe(take(1))
      .pipe(map((res) => res.data))
      .pipe(
        map((comments) =>
          comments.sort((a, b) => new Date(b.updated).valueOf() - new Date(a.updated).valueOf()),
        ),
      )
      .subscribe((sortedComments) => {
        this.comments = sortedComments;
        this.getComments();
      });
  }

  getComments() {
    let users = [];
    for (const c of this.comments) {
      c.editMode = false;
      users.push(c.last_modified_user);
    }
    if (users.length > 0)
      this.userService.getUserByUserName(users).subscribe((result) => {
        if (result.code === 200) {
          users = result.pageOfItems;
          for (const c of this.comments) {
            c.userName = c.last_modified_user;
            for (const x of users) {
              if (x.userName === c.last_modified_user) {
                c.profileUrl = x.profileUrl;
              }
            }
          }
          this.comments.sort((a: any, b: any) => {
            return new Date(b.updated).getTime() - new Date(a.updated).getTime();
          });
        }
      });
    this.cdr.detectChanges();
  }

  close(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close({ postedFirstComment: this.postedFirstComment });
  }
}
